import type { PublicUser } from './types';

const CHAVE = 'crm.contas';
const LIMITE = 8;

export interface KnownAccount {
  id: string;
  name: string;
  email: string;
  role: string;
  image: string | null;
}

/**
 * As contas que ja entraram neste navegador. Guardamos so o cartao de visita
 * - nome, email e perfil - porque a sessao mora em cookie e nao ha como
 * manter duas ao mesmo tempo: trocar de conta e entrar de novo.
 */
export function knownAccounts(): KnownAccount[] {
  try {
    const bruto = localStorage.getItem(CHAVE);
    const contas = bruto ? (JSON.parse(bruto) as KnownAccount[]) : [];

    // O email e quem identifica a conta para quem le: a mesma pessoa gravada
    // com dois ids - o do exemplo e o de verdade - apareceria duas vezes.
    return contas.filter(
      (conta, indice) => contas.findIndex((outra) => outra.email === conta.email) === indice,
    );
  } catch {
    return [];
  }
}

export function rememberAccount(user: PublicUser): void {
  const conta: KnownAccount = {
    id: user.id,
    name: user.name,
    email: user.email,
    role: user.role,
    image: user.image ?? null,
  };

  try {
    const outras = knownAccounts().filter((item) => item.email !== conta.email);
    localStorage.setItem(CHAVE, JSON.stringify([conta, ...outras].slice(0, LIMITE)));
  } catch {
    // Navegador sem armazenamento: a troca de conta some, o resto segue.
  }
}

export function forgetAccount(id: string): void {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(knownAccounts().filter((item) => item.id !== id)));
  } catch {
    // Idem: nada a fazer se o armazenamento nao aceita escrita.
  }
}

/**
 * Contas do seed, para o ambiente de desenvolvimento comecar com uma de cada
 * perfil na troca de conta. Em producao a lista nasce vazia e so cresce com
 * quem entra de verdade.
 */
const EXEMPLOS: KnownAccount[] = [
  {
    id: 'seed-admin',
    name: 'Ana Paula Ribeiro',
    email: 'admin@crm.dev',
    role: 'ADMIN',
    image: null,
  },
  {
    id: 'seed-member',
    name: 'Bruno Tavares',
    email: 'vendedor@crm.dev',
    role: 'MEMBER',
    image: null,
  },
  {
    id: 'seed-saas',
    name: 'Admin do SaaS',
    email: 'saas@crm.dev',
    role: 'SAAS_ADMIN',
    image: null,
  },
];

export function seedKnownAccounts(): void {
  if (!import.meta.env.DEV) return;

  const atuais = knownAccounts();
  const faltando = EXEMPLOS.filter(
    (exemplo) => !atuais.some((conta) => conta.email === exemplo.email),
  );

  if (faltando.length === 0) return;

  try {
    localStorage.setItem(CHAVE, JSON.stringify([...atuais, ...faltando].slice(0, LIMITE)));
  } catch {
    // Sem armazenamento nao ha o que semear.
  }
}
